import { render, staticRenderFns } from "./PreviewDesform.vue?vue&type=template&id=24fe7e46&scoped=true&"
import script from "./PreviewDesform.vue?vue&type=script&lang=js&"
export * from "./PreviewDesform.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24fe7e46",
  null
  
)

export default component.exports